export default __webpack_public_path__ + "8e7a2869da146282d0bf3de6bb6ecfa9.png";